export default __webpack_public_path__ + "static/og-7c6840b8170dd7ddc140fb413af3c7bc.jpg";